module.exports = __webpack_public_path__ + "static/media/Gressel.b11b9030.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/Logos_Lieferanten/Gressel.png
// module id = 396
// module chunks = 0